export const bookingRequestOrderDownloadUrl = (bookingRequestId: number): string =>
	`/api/provider-booking-request/${bookingRequestId}/order`;

export const bookingRequestOrderFileName = (filePath?: string | null): string =>
	filePath?.split('/').pop() ?? 'Uploaded order';

type BookingRequestOrderSource = {
	order_collection_method?: string | null;
	order_file_path?: string | null;
};

export const canViewUploadedOrder = (bookingRequest: BookingRequestOrderSource): boolean =>
	bookingRequest.order_collection_method === 'upload' && !!bookingRequest.order_file_path;
